import { FC, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  sampleGroupAtom,
  taskAtom,
  taskGroupAtom,
  taskQueueAtom,
} from 'packages/at-shell/state/recoil/task';
import { useTaskQueue } from 'packages/task-man/service/pickup';
import { mapAnnotationStateToRole } from 'packages/task-man/service/state-machine';
import { useDoesToolRequireLinkedTasks } from 'packages/at-shell/utils/use-does-tool-require-linked-tasks';
import { useToolLinkedTaskQueryParams } from 'packages/at-shell/utils/multitask-workflow-query-params';
import { useUserProfile } from 'packages/lib/utils/hooks/use-auth-data';

export const SyncTaskQueue: FC = () => {
  const task = useRecoilValue(taskAtom);
  const taskGroup = useRecoilValue(taskGroupAtom);
  const sampleGroup = useRecoilValue(sampleGroupAtom);
  const profile = useUserProfile();

  const linkTasksByObject = useDoesToolRequireLinkedTasks();
  const { object_token } = useToolLinkedTaskQueryParams();

  const { data: taskQueue, error: taskQueueError } = useTaskQueue({
    role: mapAnnotationStateToRole(task?.annotationState ?? 'ToDo') ?? 'label',
    annotationState: task?.annotationState,
    sampleGroupToken: sampleGroup?.token,
    userEmail: task?.assignee ?? profile.userProfile?.email,
    taskGroupType: taskGroup?.type,
    loadTasksByObjectToken: linkTasksByObject,
    objectToken: object_token,
  });

  const setTaskQueueAtom = useSetRecoilState(taskQueueAtom);
  useEffect(() => {
    if (!taskQueueError && task) {
      setTaskQueueAtom(taskQueue);
    } else {
      setTaskQueueAtom(null);
    }
  }, [
    task,
    sampleGroup,
    taskGroup,
    linkTasksByObject,
    object_token,
    taskQueue,
    taskQueueError,
    setTaskQueueAtom,
  ]);

  return null;
};
